import { render, staticRenderFns } from "./Grant.vue?vue&type=template&id=5de223cc&"
import script from "./Grant.vue?vue&type=script&lang=js&"
export * from "./Grant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports